// extracted by mini-css-extract-plugin
export var fullWidthButton = "_d7-0";